import React from 'react';
function Crop({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.107 3L7 15.353A1.647 1.647 0 008.647 17H21"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 7.107L15.353 7A1.647 1.647 0 0117 8.647V21"
      />
    </svg>
  );
}

export default Crop;
